<template>
  <BaseChannelTimeSeries
    :title="title"
    :item-id="itemId"
    :owner-posts="true"
    v-bind="$attrs"
  />
</template>

<script>
import proprietaryModel from '@/mixins/proprietary-model';
import BaseChannelTimeSeries from '@/components/cards/BaseChannelTimeSeries';

export default {
  name: 'PropChannelInTimeChart',
  components: {
    BaseChannelTimeSeries,
  },
  mixins: [
    proprietaryModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
  },
};
</script>

